import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { API, AUTH_REDIRECT_BASE } from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await API.get('/auth/me');
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      const hash = window.location.hash || '';
      if (hash.includes('session_id=')) {
        const sid = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
        if (sid) {
          try {
            const { data } = await API.post('/auth/google', { session_id: sid });
            setUser(data);
          } catch (e) { /* ignore */ }
          window.history.replaceState(null, '', window.location.pathname);
          setLoading(false);
          return;
        }
      }
      await refresh();
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    setUser(data);
    return data;
  };
  const register = async (email, password, name) => {
    const { data } = await API.post('/auth/register', { email, password, name });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await API.post('/auth/logout'); } catch {}
    setUser(null);
  };
  const loginWithGoogle = () => {
    const redirect = `${window.location.origin}/dashboard`;
    window.location.href = `${AUTH_REDIRECT_BASE}?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh, login, register, logout, loginWithGoogle }}>
      {children}
    </AuthContext.Provider>
  );
}
